export function px(value) {
    return `${value / 16}rem`;
}
export function containerQueryMin(minWidth) {
    return `@container (min-width: ${minWidth})`;
}
export function containerQueryMax(minWidth) {
    return `@container (max-width: ${minWidth})`;
}
export function mediaQueryMax(minWidth) {
    return `@media (max-width: ${minWidth})`;
}
